import type { SingleDataSet } from '../../../../DataProvider/types';
import type { DataConverter, SheetData } from '../types';
import { formatColumnName } from './utils';

/**
 * Convert SingleDataSet to sheet format
 * Used for bar charts and other single-dimension visualizations
 */
export const convertSingleDataToSheet: DataConverter<SingleDataSet> = ({
  data,
  primaryDimension,
  metric,
}): SheetData[] => {
  const formattedPrimaryDimension = formatColumnName(primaryDimension);
  const formattedMetricName = formatColumnName(metric);

  return data.data.map((item) => ({
    [formattedPrimaryDimension]: item.dim,
    [formattedMetricName]: item.value ?? '',
    ...(item.share !== undefined &&
      item.share !== null && { Share: item.share }),
  }));
};
